import React, { Component } from 'react'
import { object, func, bool } from 'prop-types'
import { Fieldset, Row, Field } from 'react-gridforms'
import moment from 'moment'

import CustomDatePicker from 'components/CustomDatePicker'
import Input from 'components/Input'

import Presets from './presets'
import ListFees from './list-fees'

class FormPayment extends Component {

  render() {
    const {
      item,
      isShow,
      onSearchStudent,
      onAddFee,
      loadUnpaid,
    } = this.props
    let feeLegend = "Fees"
    if (!isShow) {
      feeLegend = (
        <div className="row">
          <div className="col-xs-6">
            Fees <button type="button" disabled={isShow} onClick={onAddFee} className="btn-inline btn-icon">+</button>
          </div>
          <div className="col-xs-6 text-right">
            <Presets />
          </div>
        </div>
      )
    }

    return (
      <div>
        <Fieldset legend="Payment Information" disabled={isShow}>
          <Row>
            <Field span="1">
              <Input
                model=".orno"
                label="OR #"
                required
              />
            </Field>
            <Field span="2">
              <CustomDatePicker
                model=".paydate"
                label="Paydate"
                minDate={moment()}
                maxDate={moment().add(5, 'days')}
                disabledKeyboardNavigation
                required
              />
            </Field>
            <Field span="2" data-disabled="true">
              <Input
                model=".sy"
                label="School Year"
                disabled
              />
            </Field>
            <Field span="1" data-disabled="true">
              <Input
                model=".sem"
                label="Sem"
                disabled
              />
            </Field>
          </Row>
          <Row>
            <Field span="1">
              <Input
                model=".student_id_input"
                label="Student ID"
                onBlur={onSearchStudent}
                autoFocus
              />
            </Field>
            <Field span="2">
              <Input
                model=".payee"
                label="Payee"
                required
              />
            </Field>
            <Field span="1">
              {!!item.get('student_id') && !isShow && <button type="button" onClick={loadUnpaid} className="btn btn-info" style={{marginTop: '10px'}}>Load unpaid billing</button>}
            </Field>
          </Row>
        </Fieldset>
        <Fieldset legend={feeLegend} disabled={isShow}>
          <ListFees
            isShow={isShow}
            items={item.get('fees')}
          />
        </Fieldset>
      </div>
    )
  }
}

FormPayment.propTypes = {
  item: object,
  isShow: bool,
  onSearchStudent: func,
  onAddFee: func,
  loadUnpaid: func,
}

export default FormPayment



// WEBPACK FOOTER //
// ./src/containers/Payments/form-payment.js